import { CREATE_WASTE, READ_WASTE, READ_WASTE_LIST, WASTE_PATH } from 'domain/shared/waste';
import { Routes } from 'react-router-dom';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { createRoute, Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import WasteList from './List';
import CreateWastePage from './createupdate/Create';
import WasteViewPage from './show/WasteViewPage';

const useWasteRoute = () => {
  return createRoute({
    listRoute: WASTE_PATH,
  });
};

const WasteRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, createRoute: createWasteRoute, singleEntityRoute } = useWasteRoute();

  return (
    <ProtectedRouter basePath={WASTE_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_WASTE_LIST}>
              <WasteList />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={createWasteRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_WASTE}>
              <CreateWastePage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_WASTE}>
              <WasteViewPage />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

WasteRouter.getRouterPath = () => `${WASTE_PATH}/*`;

export default WasteRouter;
